import { useTheme } from 'contexts/ThemeContext';
import React, { useRef } from 'react';
import { GestureResponderEvent, View } from 'react-native';
import styleSheet from './styles';

export interface BlindToSwipeProps {
    onResponderMove: (value: number) => void;
    onResponderEnd?: (value: number) => void;
}

const BlindToSwipe = (props: BlindToSwipeProps) => {
    const theme = useTheme()
    const styles = styleSheet(theme);
    const startYLocation = useRef(0);

    const onResponderEnd = (event: GestureResponderEvent) => {
        props.onResponderEnd && props.onResponderEnd(event.nativeEvent.pageY - startYLocation.current);
    }

    const onResponderGrant = (event: GestureResponderEvent) => {
        startYLocation.current = event.nativeEvent.pageY;
    }

    const onResponderMove = (event: GestureResponderEvent) => {
        if (event.nativeEvent.pageY - startYLocation.current > 0) {
            props.onResponderMove(startYLocation.current - event.nativeEvent.pageY);
        }
    }

    return (
        <View
            hitSlop={{ top: 20, left: 20, right: 20, bottom: 20 }}
            style={styles.slider}
            onMoveShouldSetResponderCapture={() => true}
            onResponderGrant={onResponderGrant}
            onResponderMove={onResponderMove}
            onResponderEnd={onResponderEnd}
        />
    );
}

export default BlindToSwipe;